import { apiClient as api } from "./httpClient";

/**
 * Ditado por voz (RN-554d). O motor é escolhido pela ENTIDADE, não pelo usuário nem pela tela.
 * `engine` já vem resolvido: se a clínica pediu o servidor e ele não está de pé, volta
 * `webspeech` — profissional sem ditado nenhum seria pior que o ditado do navegador.
 */
export interface VoiceSettings {
  engine: "webspeech" | "whisper";
  /** O que a entidade escolheu, mesmo que não esteja em vigor — é o que a tela de config mostra. */
  configured: "webspeech" | "whisper";
  /** Se a transcrição própria está de pé neste ambiente (local e hml normalmente não). */
  serverReady: boolean;
  /** Se a síntese de voz está de pé neste ambiente. A chave da resposta falada é por área (RN-570). */
  speechReady: boolean;
}

export const voiceService = {
  getSettings: async (): Promise<VoiceSettings> => {
    const response = await api.get("/voice/settings");
    return response.data;
  },

  saveEngine: async (engine: "webspeech" | "whisper"): Promise<void> => {
    await api.put("/voice/settings", { engine });
  },

  /** Um trecho curto da resposta em MP3 (RN-570), na área que pediu. O áudio não é guardado no servidor. */
  speak: async (text: string, areaKey: string, signal?: AbortSignal): Promise<Blob> => {
    const response = await api.post("/voice/speak", { text, areaKey }, { responseType: "blob", signal });
    return response.data;
  },

  /** Um trecho de fala. O servidor enfileira uma por vez — a espera é normal, não erro. */
  transcribe: async (audio: Blob): Promise<string> => {
    const form = new FormData();
    form.append("audio", audio, "fala.webm");
    // FormData exige Content-Type nulo: com o padrão do axios o boundary se perde e volta 415.
    const response = await api.post("/voice/transcribe", form, {
      headers: { "Content-Type": null },
    });
    return response.data?.text || "";
  },
};
